export const es = {
  translation: {
    auth: {
      notAMember: "¿No eres miembro?",
      signUp: "Registrarse",
      up: "Arriba",
      business: "Negocio",
      signIn: "Iniciar Sesión",
      signInDescription: "Inicia sesión si tienes una cuenta aquí",
      alreadyHaveAccount: "¿Ya tienes una cuenta?",
      signUpDescription: "Regístrate si no tienes una cuenta",
    },
    businessSignIn: {
      emailLabel: "Tu Correo Electrónico",
      emailPlaceholder: "Correo Electrónico",
      passwordLabel: "Contraseña",
      passwordPlaceholder: "Ingresa Tu Contraseña",
      forgotPassword: "¿Olvidaste tu Contraseña?",
      signInButton: "Iniciar Sesión",
      orSignInWith: "O Inicia sesión con",
      invalidEmail: "Dirección de correo electrónico inválida",
      emailRequired: "El correo electrónico es requerido",
      passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
      passwordRequired: "La contraseña es requerida",
    },
    businessSignUp: {
      firstNameLabel: "Nombre",
      firstNamePlaceholder: "Ingresa Tu Nombre",
      lastNameLabel: "Apellido",
      lastNamePlaceholder: "Ingresa Tu Apellido",
      emailLabel: "Tu Correo Electrónico",
      emailPlaceholder: "Correo Electrónico",
      passwordLabel: "Contraseña",
      passwordPlaceholder: "Ingresa Tu Contraseña",
      confirmPasswordLabel: "Confirmar Contraseña",
      confirmPasswordPlaceholder: "Confirma Tu Contraseña",
      signUpButton: "Registrarse",
      orSignUpWith: "O Regístrate con",
      google: "Google",
      facebook: "Facebook",
      twitter: "Twitter",
      apple: "Apple",
      firstNameRequired: "El nombre es requerido",
      lastNameRequired: "El apellido es requerido",
      emailRequired: "El correo electrónico es requerido",
      passwordRequired: "La contraseña es requerida",
      confirmPasswordRequired: "Confirmar contraseña es requerido",
      invalidEmail: "Dirección de correo electrónico inválida",
      passwordMinLength: "La contraseña debe tener al menos 6 caracteres",
      passwordsMustMatch: "Las contraseñas deben coincidir",
    },
    forgotPassword: {
      title: "Olvidaste tu Contraseña",
      subtitle: "¿Olvidaste tu contraseña? Te ayudamos a recuperarla.",
      emailLabel: "Tu Correo Electrónico",
      emailPlaceholder: "Correo Electrónico",
      nextButton: "Siguiente",
      rememberedAccount: "¿Recordaste tu cuenta?",
      invalidEmail: "Dirección de correo electrónico inválida",
      emailRequired: "El correo electrónico es requerido",
      errorMessage: "Ocurrió un error",
    },
    verifyOtp: {
      verify: "Verificar",
      otp: "OTP",
      subtitle: "Ingresa el OTP enviado a tu correo electrónico para continuar",
      enterOtpLabel: "Ingresa OTP",
      enterOtpPlaceholder: "Ingresa código de 4 dígitos",
      resendOtp: "Reenviar OTP",
      rememberedAccount: "¿Recordaste tu cuenta?",
      next: "Siguiente",
      otpRequired: "El OTP es requerido",
      otpLength: "El OTP debe tener 4 dígitos",
      otpResent: "El OTP ha sido reenviado a tu correo electrónico",
      errorMessage: "Ocurrió un error",
    },
    resetPassword: {
      title: "Restablecer",
      password: "Contraseña",
      subtitle: "¿Restablecer tu contraseña? Te ayudamos a recuperarla.",
      newPasswordLabel: "Nueva Contraseña",
      newPasswordPlaceholder: "Ingresa Nueva Contraseña",
      confirmPasswordLabel: "Confirmar Contraseña",
      confirmPasswordPlaceholder: "Confirmar Contraseña",
      resetButton: "Restablecer",
      rememberedAccount: "¿Recordaste tu cuenta?",
      passwordRequired: "La contraseña es requerida",
      confirmPasswordRequired: "Confirmar contraseña es requerido",
      passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
      passwordsMustMatch: "Las contraseñas deben coincidir",
      successMessage:
        "¡Contraseña restablecida exitosamente! Por favor inicia sesión con tu nueva contraseña.",
      errorMessage: "Ocurrió un error",
    },
    splitLayout: {
      logo: "LOGO",
      logoAlt: "LOGO",
      reviewsWebsite: "Sitio Web de Reseñas",
      reviewsManagementSystem: "Sistema de Gestión de Reseñas",
      affiliateDescription:
        "Únete a nuestra red de afiliados y gana comisiones ayudando a las empresas a descubrir nuestra plataforma. Conecta empresas locales con clientes y gana recompensas por cada suscripción exitosa.",
    },
    passwordSettings: {
      title: "Configuración de Contraseña",
      currentPassword: "Contraseña Actual",
      currentPasswordPlaceholder: "Ingresa tu contraseña actual",
      newPassword: "Nueva Contraseña",
      newPasswordPlaceholder: "Ingresa tu nueva contraseña",
      confirmNewPassword: "Confirmar Nueva Contraseña",
      confirmNewPasswordPlaceholder: "Confirma tu nueva contraseña",
      changePassword: "Cambiar Contraseña",
      currentPasswordRequired: "La contraseña actual es requerida",
      newPasswordRequired: "La nueva contraseña es requerida",
      confirmPasswordRequired: "Por favor confirma tu nueva contraseña",
      passwordMinLength: "La contraseña debe tener al menos 8 caracteres",
      passwordDifferentFromCurrent:
        "La nueva contraseña debe ser diferente a la actual",
      passwordsMustMatch: "Las contraseñas deben coincidir",
    },
    businessCard: {
      status: {
        live: "En Vivo",
        pending: "Pendiente",
        draft: "Borrador",
        rejected: "Rechazado",
      },
      aboutLabel: "Acerca de",
      reviews: "Reseñas",
      review: "Reseña",
      manageBusiness: "Gestionar Negocio",
      manageBusinessAria: "Abrir configuración de {{name}}",
    },
    businessStatus: {
      title: "Estado del Negocio",
      changeStatus: "Cambiar Estado",
      cancel: "Cancelar",
      update: "Actualizar",
      newStatus: "Nuevo Estado",
      selectNewStatus: "Seleccionar nuevo estado",
      success: "Éxito",
      updateSuccess: "Estado del negocio actualizado exitosamente",
      error: "Error",
      updateError: "Error al actualizar el estado del negocio",
      rejectedWarning:
        "Los negocios rechazados no son visibles para los clientes. Por favor revisa la información de tu negocio y vuelve a enviar para aprobación.",
      descriptions: {
        draft: "Tu negocio está en modo borrador y no es visible para el público.",
        pending: "Tu negocio está bajo revisión y será publicado pronto.",
        published: "Tu negocio está activo y visible para los clientes.",
        rejected: "Tu negocio fue rechazado. Por favor revisa y vuelve a enviar.",
      },
      labels: {
        draft: "Borrador",
        pending: "En revisión",
        published: "Publicado",
        rejected: "Rechazado",
      },
    },
    customColorPicker: {
      pickAColor: "Elige un color",
    },
    colorsForm: {
      colors: "Colores",
      primary: "Primario",
      background: "Fondo",
      card: "Tarjeta",
      text: "Texto",
      textOnPrimary: "Texto sobre Primario",
    },
    galleryManagement: {
      gallery: "Galería",
      addImages: "Agregar Imágenes",
      uploadImages: "Subir Imágenes",
      selectImages: "Seleccionar Imágenes",
      chooseMultipleImages: "Elige múltiples imágenes",
      cancel: "Cancelar",
      upload: "Subir",
      galleryImage: "Imagen de galería",
      noImagesUploadedYet: "Aún no se han subido imágenes",
      uploadImagesToShowcase: "Sube imágenes para mostrar tu negocio",
      success: "Éxito",
      error: "Error",
      imagesUploadedSuccessfully: "Imágenes subidas exitosamente",
      failedToUploadImages: "Error al subir las imágenes",
      imageDeletedSuccessfully: "Imagen eliminada exitosamente",
      failedToDeleteImage: "Error al eliminar la imagen",
    },
    operationHours: {
      title: "Horarios de Operación",
      previewBlurb: "Horario habitual por día. Actualízalo en la pestaña Horario si cambia.",
      edit: "Editar",
      cancel: "Cancelar",
      save: "Guardar",
      open: "Abierto",
      closed: "Cerrado",
      openTime: "Hora de apertura",
      closeTime: "Hora de cierre",
      to: "a",
      success: "Éxito",
      updateSuccess: "Horarios de operación actualizados exitosamente",
      error: "Error",
      updateError: "Error al actualizar los horarios de operación",
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
      },
    },
    operationTimes: {
      title: "Horarios de Operación",
      from: "Desde",
      to: "Hasta",
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
      },
    },
    renderStars: {
      rating: "Calificación",
      stars: "Estrellas",
    },
    dashboard: {
      openMenu: "Abrir menú",
      closeMenu: "Cerrar menú",
      businesses: "Negocios",
      shop: "Tienda",
      reviews: "Reseñas",
      offers: "Ofertas",
      settings: "Configuración",
      logout: "Cerrar Sesión",
      confirmLogout: "¿Confirmar Cierre de Sesión?",
      logoutMessage: "¿Quieres salir de la aplicación?",
      keepUsingApp: "No, seguir usando la aplicación",
      yes: "Sí",
    },
    createBusiness: {
      title: "Crear Nuevo Negocio",
      businessName: "Nombre del Negocio",
      businessNamePlaceholder: "Nombre del Negocio",
      businessCategory: "Categoría del Negocio",
      selectCategoryPlaceholder: "Selecciona una categoría",
      create: "Crear",
    },
    businesses: {
      title: "Negocios",
      noBusinessesYet: "Aún no hay negocios",
      getStartedDescription:
        "Comienza creando tu primer negocio y empieza a gestionar tus reseñas",
      createFirstBusiness: "Crea Tu Primer Negocio",
      addNewBusiness: "Agregar Nuevo Negocio",
      websiteUsage: "Sitios web usados: {{used}} / {{allowed}}",
      websiteLimitReachedTitle: "Límite de sitios web alcanzado",
      websiteLimitReachedDescription:
        "Has alcanzado el número máximo de sitios web para tu plan de suscripción actual. Ve a Configuración de suscripción para actualizar y añadir más sitios web.",
      manageSubscriptionButton: "Gestionar suscripción",
      viewGrid: "Cuadrícula",
      viewTable: "Tabla",
      viewModeAria: "Disposición de la lista de negocios",
      table: {
        business: "Negocio",
        status: "Estado",
        category: "Categoría",
        location: "Ubicación",
        reviews: "Reseñas",
        actions: "Acciones",
      },
    },
    businessReviews: {
      businessReviews: "Reseñas del Negocio",
      totalReviews: "Total de Reseñas",
      reviewImageFullView: "Vista completa de imagen de reseña",
      reviewImage: "Imagen de reseña",
      reviewImages: "Imágenes de Reseña",
      more: "más",
      business: "Negocio",
      unknownBusiness: "Negocio desconocido",
      noReviewsFound: "No se encontraron reseñas",
      page: "Página",
      of: "de",
      showing: "Mostrando",
      reviews: "reseñas",
      errorLoadingReviews: "Error al Cargar Reseñas",
      failedToLoadReviews: "Error al cargar las reseñas. Por favor inténtalo de nuevo.",
      generateAIReply: "Generar Respuesta IA",
      postReply: "Publicar Respuesta",
      replyPlaceholder: "Escribe tu respuesta...",
      businessReply: "Respuesta del Negocio",
      aiReplyGenerated: "Respuesta IA Generada",
      editAndPostReply: "Edita la respuesta si es necesario y haz clic en Publicar Respuesta",
      replyPosted: "Respuesta publicada exitosamente",
      replyCannotBeEmpty: "La respuesta no puede estar vacía",
      failedToGenerateReply: "Error al generar respuesta IA. Por favor inténtalo de nuevo.",
      failedToPostReply: "Error al publicar respuesta. Por favor inténtalo de nuevo.",
      error: "Error",
      success: "Éxito",
      sendOffer: "Enviar Oferta",
    },
    offers: {
      title: "Ofertas de Fidelización",
      totalOffers: "Total de Ofertas",
      noOffersFound: "No se encontraron ofertas",
      errorLoading: "Error al Cargar Ofertas",
      failedToLoad: "Error al cargar las ofertas. Por favor inténtalo de nuevo.",
      success: "Éxito",
      error: "Error",
      markedRedeemed: "Oferta marcada como canjeada",
      failedToRedeem: "Error al marcar la oferta como canjeada. Por favor inténtalo de nuevo.",
      redeemed: "Canjeada",
      active: "Activa",
      markRedeemed: "Marcar como Canjeada",
      business: "Negocio",
      expires: "Caduca",
      sentAt: "Enviada",
      page: "Página",
      of: "de",
      showing: "Mostrando",
      offers: "ofertas",
    },
    loyaltyCards: {
      title: "Tarjetas de Fidelización",
      totalCards: "Total de Tarjetas",
      noCardsFound: "No se encontraron tarjetas de fidelización",
      errorLoading: "Error al Cargar las Tarjetas",
      failedToLoad: "Error al cargar las tarjetas de fidelización. Por favor inténtalo de nuevo.",
      stamps: "sellos",
      rewardsEarned: "Recompensas obtenidas",
    },
    loyaltySettings: {
      title: "Programa de Fidelización",
      subtitle:
        "Recompensa a los clientes que dejan reseñas positivas repetidas con una oferta automática al alcanzar un número de sellos.",
      enable: "Activar programa de fidelización",
      threshold: "Sellos necesarios para una recompensa",
      thresholdDescription: "Número de reseñas positivas (4+ estrellas) necesarias para obtener una recompensa.",
      description: "Descripción de la Recompensa",
      expiryDays: "La recompensa caduca después de (días)",
      expiryDaysDescription: "Cuántos días permanece válida la oferta generada automáticamente.",
      save: "Guardar Configuración",
      success: "Éxito",
      error: "Error",
      saved: "Configuración del programa de fidelización guardada",
      failedToSave: "Error al guardar la configuración del programa de fidelización. Por favor inténtalo de nuevo.",
      errorLoading: "Error al Cargar la Configuración",
      failedToLoad: "Error al cargar la configuración del programa de fidelización. Por favor inténtalo de nuevo.",
    },
    sendOffer: {
      title: "Enviar Oferta de Fidelización",
      subtitle: "Envía una oferta especial a {{name}} para recompensar su reseña",
      offerType: "Tipo de Oferta",
      selectOfferType: "Selecciona el tipo de oferta",
      types: {
        discount: "Descuento",
        freeItem: "Artículo Gratis",
        other: "Otro",
      },
      description: "Descripción de la Oferta",
      descriptionPlaceholder: "Describe la oferta (ej. 20% de descuento en la próxima visita, postre gratis...)",
      expiryDate: "Fecha de Vencimiento",
      selectDate: "Selecciona la fecha de vencimiento",
      cancel: "Cancelar",
      send: "Enviar Oferta",
      success: "Éxito",
      error: "Error",
      offerSent: "Oferta enviada al cliente exitosamente",
      failedToSend: "Error al enviar la oferta. Por favor inténtalo de nuevo.",
      fillAllFields: "Por favor completa todos los campos",
    },
    businessSettings: {
      title: "Configuración",
      privacy: "Privacidad",
      business: "Negocio",
      loyalty: "Fidelización",
      subscription: "Suscripción",
    },
    subscription: {
      status: {
        active: "Activa",
        canceled: "Cancelada",
        cancelled: "Cancelada",
        past_due: "Vencida",
        incomplete: "Incompleta",
        trialing: "Prueba",
        unpaid: "Sin pagar",
        paused: "Pausada",
        unknown: "Desconocido",
      },
      invoiceStatus: {
        paid: "Pagada",
        open: "Abierta",
        draft: "Borrador",
        void: "Anulada",
        uncollectible: "Incobrable",
        unknown: "Desconocido",
      },
      current: {
        title: "Suscripción Actual",
        plan: "Plan",
        price: "Precio",
        month: "mes",
        nextPayment: "Próximo Pago",
        cancelWarning:
          "Tu suscripción será cancelada al final del período de facturación actual.",
        cancelButton: "Cancelar Suscripción",
        noSubscription: {
          title: "Sin Suscripción Activa",
          description: "No tienes una suscripción activa",
        },
      },
      billing: {
        title: "Historial de Facturación",
        table: {
          invoice: "Factura",
          date: "Fecha",
          amount: "Monto",
          status: "Estado",
          actions: "Acciones",
        },
        actions: {
          viewInvoice: "Ver Factura",
          payNow: "Pagar Ahora",
          processing: "Procesando...",
        },
        noInvoices: {
          title: "Sin Facturas",
          description: "Aún no tienes historial de facturación",
        },
      },
      cancelModal: {
        title: "Cancelar Suscripción",
        description:
          "¿Estás seguro de que quieres cancelar tu suscripción? Continuarás teniendo acceso hasta el final de tu período de facturación actual.",
        warning:
          "Esta acción no se puede deshacer. Tu suscripción será cancelada inmediatamente y no se te cobrará por períodos de facturación futuros.",
        keepButton: "Mantener Suscripción",
        cancelButton: "Cancelar Suscripción",
      },
      notifications: {
        cancelled: {
          title: "Suscripción Cancelada",
          message: "Tu suscripción ha sido cancelada exitosamente.",
        },
        error: {
          title: "Error",
          message: "Error al cancelar la suscripción. Por favor inténtalo de nuevo.",
        },
        paymentSuccess: {
          title: "Pago Exitoso",
          message: "La factura ha sido pagada exitosamente.",
        },
        paymentFailed: {
          title: "Pago Fallido",
          message: "Error al pagar la factura. Por favor inténtalo de nuevo.",
        },
      },
      error: {
        title: "Error al Cargar Suscripción",
        message: "Error al cargar la información de la suscripción. Por favor inténtalo de nuevo.",
      },
    },
    contactInformation: {
      title: "Información de Contacto",
      websiteUrlLabel: "URL del Sitio Web",
      websiteUrlPlaceholder: "URL del Sitio Web",
      googleUrlLabel: "URL de Google",
      googleUrlPlaceholder: "URL de Google",
      facebookUrlLabel: "URL de Facebook",
      facebookUrlPlaceholder: "URL de Facebook",
      twitterUrlLabel: "URL de Twitter",
      twitterUrlPlaceholder: "URL de Twitter",
      iphoneUrlLabel: "URL de Iphone",
      iphoneUrlPlaceholder: "URL de Iphone",
      phoneLabel: "Teléfono #",
      phonePlaceholder: "Teléfono #",
    },
    contactInfo: {
      title: "Información de Contacto",
      website: "Sitio Web",
      email: "Correo Electrónico",
      callUs: "Llámanos",
      getDirections: "Obtener Direcciones",
      openInMaps: "Abrir en Google Maps",
      emptyTitle: "Sin datos de contacto",
      emptyHint: "Añade teléfono, correo, web o redes — se mostrarán aquí al instante.",
      clickToAdd: "Haz clic para agregar información de contacto",
      socialMedia: {
        title: "Redes Sociales",
        facebook: "Facebook",
        twitter: "Twitter",
        instagram: "Instagram",
        linkedin: "LinkedIn",
        youtube: "YouTube",
        tiktok: "TikTok",
        snapchat: "Snapchat",
      },
    },
    faqs: {
      title: "Preguntas Frecuentes",
      question1Label: "Pregunta 1",
      question1Placeholder: "Pregunta 1",
      question2Label: "Pregunta 2",
      answer2Placeholder: "Respuesta 2",
      answerLabel: "Respuesta",
      answer1Placeholder: "Respuesta 1",
    },
    faqsSection: {
      title: "Preguntas Frecuentes",
      intro: "Respuestas claras reducen dudas repetidas y ayudan a decidir.",
      untitledQuestion: "Pregunta",
      edit: "Editar",
      addFAQs: "Agregar Preguntas Frecuentes",
      emptyTitle: "Aún no hay preguntas",
      emptyStateMessage:
        "Añade preguntas y respuestas en el editor — aparecerán aquí para los visitantes.",
    },
    faqsSectionForm: {
      title: "Editar Sección de Preguntas Frecuentes",
      question: "Pregunta",
      questionPlaceholder: "Ingresa tu pregunta",
      answer: "Respuesta",
      answerPlaceholder: "Ingresa tu respuesta",
      remove: "Eliminar",
      addFAQ: "Agregar Pregunta Frecuente",
      cancel: "Cancelar",
      save: "Guardar",
      validation: {
        questionRequired: "La pregunta es requerida",
        answerRequired: "La respuesta es requerida",
      },
    },
    generalInformation: {
      title: "Información General",
      logo: "Logo",
      coverImage: "Imagen de Portada",
      businessName: "Nombre del Negocio",
      businessNamePlaceholder: "Nombre del Negocio",
      aboutUs: "Sobre Nosotros",
      aboutUsPlaceholder: "Sobre Nosotros",
      address: "Dirección",
      addressLine1: "Línea de Dirección 1",
      addressLine2: "Línea de Dirección 2",
      country: "País",
      state: "Estado",
      city: "Ciudad",
      zipCode: "Código Postal",
      addressPlaceholder: "Dirección",
      zipCodePlaceholder: "123444",
    },
    imagesForm: {
      title: "Imágenes",
      importFromInstagram: "Importar desde Instagram",
      uploadImages: "Subir Imágenes",
      uploadedPhoto: "Foto subida",
      selected: "Seleccionado",
      remove: "Eliminar",
    },
    aboutUs: {
      emptyTitle: "La sección \"Acerca de\" está vacía",
      emptyHint: "Explica qué hace único a tu negocio — añade tu historia en el editor.",
      title: "Sobre Nosotros",
      clickToAddStory: "Haz clic para agregar la historia de tu negocio",
    },
    aboutUsForm: {
      editHeroSection: "Editar Sección Hero",
      aboutUs: "Sobre Nosotros",
      cancel: "Cancelar",
      save: "Guardar",
      businessNameRequired: "El nombre del negocio es requerido",
    },
    colorsSection: {
      primaryColor: "Color Primario",
      backgroundColor: "Color de Fondo",
      cardColor: "Color de Tarjeta",
      textColor: "Color de Texto",
    },
    colorsSectionForm: {
      editColorsSection: "Editar Sección de Colores",
      primaryColor: "Color Primario",
      backgroundColor: "Color de Fondo",
      cardColor: "Color de Tarjeta",
      textColor: "Color de Texto",
      textOnPrimaryColor: "Texto sobre Color Primario",
      save: "Guardar",
      validation: {
        primaryColorRequired: "El color primario es requerido",
        backgroundColorRequired: "El color de fondo es requerido",
        cardColorRequired: "El color de tarjeta es requerido",
        textColorRequired: "El color de texto es requerido",
        textOnPrimaryColorRequired: "El texto sobre color primario es requerido",
      },
    },
    contactInfoForm: {
      title: "Editar Información de Contacto",
      basicContact: "Contacto Básico",
      socialMedia: "Redes Sociales",
      websiteUrl: "URL del Sitio Web",
      websiteUrlPlaceholder: "https://www.tusitio.com",
      emailAddress: "Dirección de Correo Electrónico",
      emailAddressPlaceholder: "contacto@tunegocio.com",
      phoneNumber: "Número de Teléfono",
      phoneNumberPlaceholder: "+1 (555) 123-4567",
      googleUrl: "URL de Google Maps (mapa en tu página)",
      googleUrlPlaceholder: "Pega el iframe de incrustación o un enlace https://www.google.com/maps/...",
      googleUrlDescription: "Solo para el mapa / \"abrir en Google Maps\" en tu ficha pública.",
      googleReviewUrl: "Enlace de reseñas en Google",
      googleReviewUrlPlaceholder: "https://search.google.com/local/writereview?placeid=…",
      googleReviewUrlDescription: "Solo se usa cuando invitamos al cliente a publicar en Google después de enviar la reseña aquí.",
      googleUrlGuideTitle: "Cómo añadir tu mapa (recomendado)",
      googleUrlGuideIntro: "\"Insertar un mapa\" evita la mayoría de errores al copiar.",
      googleUrlStep1: "Abre Google Maps en el navegador (en escritorio es más fácil).",
      googleUrlStep2: "Busca tu negocio o mueve el mapa hasta que el pin coincida con tu ubicación.",
      googleUrlStep3: "Pulsa Compartir.",
      googleUrlStep4: "Elige \"Insertar un mapa\" (no solo \"Enviar enlace\").",
      googleUrlStep5: "Copia el iframe completo, o solo la URL larga https://www.google.com/maps/... que está dentro de src=\"...\".",
      googleUrlStep6: "Pégala en el campo de abajo y guarda.",
      googleUrlTestHint: "¿Abrir Maps?",
      googleUrlOpenMapsLink: "Abrir Google Maps",
      googleReviewsGuideTitle: "Cómo configurar el enlace de reseñas en Google",
      googleReviewsGuideIntro: "Es independiente del mapa: solo define a dónde va el botón \"Abrir reseñas en Google\".",
      googleReviewsStep1: "Lo ideal: pega la URL directa de reseña.",
      googleReviewsStep2: "O pega un enlace normal de Google Maps.",
      googleReviewsStep3: "Si lo dejas vacío, usamos la URL del mapa de arriba.",
      facebookUrl: "URL de Facebook",
      facebookUrlPlaceholder: "https://facebook.com/tunegocio",
      twitterUrl: "URL de Twitter",
      twitterUrlPlaceholder: "https://twitter.com/tunegocio",
      instagramUrl: "URL de Instagram",
      instagramUrlPlaceholder: "https://instagram.com/tunegocio",
      linkedinUrl: "URL de LinkedIn",
      linkedinUrlPlaceholder: "https://linkedin.com/company/tunegocio",
      youtubeUrl: "URL de YouTube",
      youtubeUrlPlaceholder: "https://youtube.com/@tunegocio",
      tiktokUrl: "URL de TikTok",
      tiktokUrlPlaceholder: "https://tiktok.com/@tunegocio",
      snapchatUrl: "URL de Snapchat",
      snapchatUrlPlaceholder: "https://snapchat.com/add/tunegocio",
      cancel: "Cancelar",
      save: "Guardar",
      validation: {
        websiteUrlInvalid: "Por favor ingresa una URL válida",
        emailInvalid: "Por favor ingresa un correo electrónico válido",
        googleUrlInvalid: "Por favor ingresa una URL válida",
        googleUrlNotGoogleMaps: "Usa una URL de Google Maps o pega el iframe de incrustación.",
        googleReviewUrlInvalid: "Usa un enlace de Google Maps o un enlace writereview.",
        facebookUrlInvalid: "Por favor ingresa una URL válida",
        twitterUrlInvalid: "Por favor ingresa una URL válida",
        instagramUrlInvalid: "Por favor ingresa una URL válida",
        linkedinUrlInvalid: "Por favor ingresa una URL válida",
        youtubeUrlInvalid: "Por favor ingresa una URL válida",
        tiktokUrlInvalid: "Por favor ingresa una URL válida",
        snapchatUrlInvalid: "Por favor ingresa una URL válida",
      },
    },
    footerSection: {
      tagline: "Enlaces y redes que los visitantes usan para contactarte.",
      businessDescription: "Descripción del negocio",
      socialMedia: {
        facebook: "Facebook",
        twitter: "Twitter",
        google: "Google",
        instagram: "Instagram",
        linkedin: "LinkedIn",
        youtube: "YouTube",
        tiktok: "TikTok",
        snapchat: "Snapchat",
      },
      all: "Todos",
      rightsReserved: "Derechos Reservados",
    },
    footerSectionForm: {
      title: "Editar Información de Contacto",
      websiteUrl: "URL del Sitio Web",
      websiteUrlPlaceholder: "https://www.ejemplo.com",
      emailAddress: "Dirección de Correo Electrónico",
      emailAddressPlaceholder: "contacto@ejemplo.com",
      phoneNumber: "Número de Teléfono",
      phoneNumberPlaceholder: "+1 (555) 123-4567",
      googleUrl: "URL de Google Maps (mapa en tu página)",
      googleUrlPlaceholder: "Pega el iframe de incrustación o un enlace https://www.google.com/maps/...",
      googleReviewUrl: "Enlace de reseñas en Google",
      googleReviewUrlPlaceholder: "https://search.google.com/local/writereview?placeid=…",
      twitterUrl: "URL de Twitter",
      twitterUrlPlaceholder: "https://twitter.com/...",
      facebookUrl: "URL de Facebook",
      facebookUrlPlaceholder: "https://facebook.com/...",
      instagramUrl: "URL de Instagram",
      instagramUrlPlaceholder: "https://instagram.com/...",
      linkedinUrl: "URL de LinkedIn",
      linkedinUrlPlaceholder: "https://linkedin.com/...",
      youtubeUrl: "URL de YouTube",
      youtubeUrlPlaceholder: "https://youtube.com/...",
      tiktokUrl: "URL de TikTok",
      tiktokUrlPlaceholder: "https://tiktok.com/...",
      snapchatUrl: "URL de Snapchat",
      snapchatUrlPlaceholder: "https://snapchat.com/...",
      cancel: "Cancelar",
      save: "Guardar",
      validation: {
        websiteUrlInvalid: "URL inválida",
        emailInvalid: "Dirección de correo electrónico inválida",
        googleUrlInvalid: "URL inválida",
        twitterUrlInvalid: "URL inválida",
        facebookUrlInvalid: "URL inválida",
        instagramUrlInvalid: "URL inválida",
        linkedinUrlInvalid: "URL inválida",
        youtubeUrlInvalid: "URL inválida",
        tiktokUrlInvalid: "URL inválida",
        snapchatUrlInvalid: "URL inválida",
      },
    },
    gallery: {
      title: "Galería",
      manageImages: "Gestionar Imágenes",
      remove: "Eliminar",
      galleryImageAlt: "Foto de la galería",
      imageUnavailable: "No se pudo cargar la imagen",
      noImagesYet: "Aún No Hay Imágenes",
      emptyVisitor: "Las fotos que subas aparecerán aquí en tu página pública.",
      clickToAddPhotos: "Haz clic en \"Gestionar Imágenes\" para agregar fotos a tu galería",
    },
    galleryForm: {
      editGallery: "Editar Galería",
      addImages: "Agregar Imágenes",
      cancel: "Cancelar",
      save: "Guardar",
    },
    heroSection: {
      coverImageAlt: "Imagen de portada de {{name}}",
      reviews: "{{count}} Reseñas",
      randomLocation: "Ubicación Aleatoria",
      writeReview: "Escribir una reseña",
      ratingLine: "{{score}} de media (reseñas publicadas)",
      noRatingYet: "La media aparece cuando haya reseñas publicadas",
      addressPlaceholder: "Tu dirección se mostrará aquí cuando la añadas en el editor",
      noCoverTitle: "Imagen de portada",
      noCoverHint: "Sube una portada en Perfil y ubicación para mostrarla aquí.",
      businessNameFallback: "Nombre de tu negocio",
      logoPlaceholderAria: "Sin logo",
    },
    heroSectionForm: {
      title: "Editar Sección Hero",
      uploadLogo: "Subir Logo",
      uploadCoverImage: "Subir Imagen de Portada",
      businessName: "Nombre del Negocio",
      businessNamePlaceholder: "Nombre del Negocio",
      address: "Dirección",
      address1: "Línea de Dirección 1",
      address1Placeholder: "Ingrese línea de dirección 1",
      address2: "Línea de Dirección 2",
      address2Placeholder: "Ingrese línea de dirección 2 (opcional)",
      city: "Ciudad",
      cityPlaceholder: "Ingrese ciudad",
      state: "Estado/Provincia",
      statePlaceholder: "Ingrese estado o provincia",
      country: "País",
      countryPlaceholder: "Ingrese país",
      zip: "Código Postal",
      zipPlaceholder: "Ingrese código postal",
      cancel: "Cancelar",
      save: "Guardar",
      validation: {
        businessNameRequired: "El nombre del negocio es requerido",
        address1Required: "La línea de dirección 1 es requerida",
        cityRequired: "La ciudad es requerida",
        stateRequired: "El estado/provincia es requerido",
        countryRequired: "El país es requerido",
        zipRequired: "El código postal es requerido",
      },
    },
    reviewCard: {
      title: "Reseña",
      outOf5: "de 5",
      stars: "Estrellas",
    },
    reviewCard2: {
      sampleReview: {
        name: "Sarah Johnson",
        comment:
          "¡Servicio absolutamente fantástico! El equipo superó nuestras expectativas.",
      },
    },
    reviewsHighlight: {
      title: "Valoraciones",
      subtitle: "Media de las reseñas ya publicadas en tu web.",
      averageLabel: "Media {{score}} de 5",
      noReviewsYet: "Sin media publicada aún — habrá nota cuando haya reseñas en vivo",
    },
    timingSection: {
      operationTimes: "Horarios de Operación",
      notSet: "No establecido",
      closed: "Cerrado",
      clickToSetHours: "Haz clic para establecer los horarios de tu negocio",
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
      },
    },
    timingSectionForm: {
      title: "Horarios del Negocio",
      open: "Abierto",
      openTime: "Abrir",
      closeTime: "Cerrar",
      cancel: "Cancelar",
      save: "Guardar",
      days: {
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        sunday: "Domingo",
      },
    },
    businessProfileSetup: {
      loading: "Cargando...",
    },
    unifiedBusinessEdit: {
      modalTitle: "Editar datos del negocio",
      modalHint: "Usa las pestañas para actualizar la página; la vista previa refleja los cambios antes de guardar.",
      tabProfile: "Perfil y ubicación",
      tabAbout: "Acerca de",
      tabContact: "Contacto y redes",
      tabTheme: "Tema",
      tabGallery: "Galería",
      tabFaqs: "Preguntas frecuentes",
      tabHours: "Horario",
    },
    businessWebsitePreview: {
      pageTitle: "Tu página de negocio",
      pageSubtitle: "Edita a la izquierda: la vista previa se actualiza al escribir.",
      locationTitle: "Ubicación",
      locationBlurb: "Facilita la visita presencial. Añade un enlace de Google Maps en Contacto y redes para mostrar el mapa aquí.",
      mapEmbedHint: "Para un mapa integrado: Google Maps → Compartir → Insertar mapa.",
      editDetails: "Editar detalles",
      qrCode: "Código QR",
      qrCodeTitle: "Código QR de la página",
      publishWebsite: "Publicar Sitio Web",
      pendingApproval: "Pendiente de Aprobación",
      markAsDraft: "Marcar como Borrador",
      statusDraft: "Borrador",
      statusPending: "En revisión",
      statusPublished: "Publicado",
      statusRejected: "Rechazado",
      googleMap: "Mapa de Google",
      mapEmbedHelp: "Este enlace no es de incrustación.",
      mapOpenInGoogleMaps: "Abrir en Google Maps",
      mapNoLocation: "Aún no hay mapa",
      mapPlaceholderHint: "Pega un enlace o la incrustación de Google Maps en Contacto y redes.",
      downloadQRCode: "Descargar Código QR",
    },
    completeSubscription: {
      user: "Usuario",
      logout: "Cerrar Sesión",
      chooseSubscriptionPlan: "Elige Tu Plan de Suscripción",
      plansLoadErrorTitle: "No se pudieron cargar los planes",
      plansLoadErrorBody: "No se pudo conectar con el cobro. Comprueba tu conexión o inténtalo de nuevo.",
      retry: "Reintentar",
      plansEmpty: "No hay planes que coincidan.",
      perMonthPerSeat: "/month",
      noDescriptionAvailable: "No description available",
      paymentMethod: "Método de Pago",
      orderSummary: "Order Summary",
      plan: "Plan",
      amount: "Amount",
      termsAndPrivacyText: "By clicking Subscribe, you agree to our",
      termsAndConditions: "Terms and Conditions",
      and: "and",
      privacyPolicy: "Privacy Policy",
      subscribeNow: "Subscribe Now!",
      promotionCodeLabel: "Código promocional (opcional)",
      promotionCodePlaceholder: "Introduce el código si tienes uno",
      promotionCodeHint: "Socios beta: intróducelo en Premium para dos meses gratis.",
      promotionCodeHintCheckout: "Opcional: intróducelo aquí para Premium.",
      continueToCheckout: "Continuar al pago seguro",
    },
    subscriptionCheckout: {
      syncing: "Actualizando tu cuenta…",
      successTitle: "Suscripción activada",
      successBody: "El pago se completó correctamente. Puedes ir al panel de control.",
      sessionRef: "Referencia de pago",
      continueToDashboard: "Ir al panel",
      syncError: "No pudimos actualizar tu cuenta. Inicia sesión de nuevo o inténtalo más tarde.",
      signInAgain: "Iniciar sesión",
      cancelTitle: "Pago cancelado",
      cancelBody: "No se completó ningún pago. Puedes volver a los planes e intentarlo de nuevo.",
      backToPlans: "Volver a los planes de suscripción",
    },
    paymentMethods: {
      title: "Detalles de Pago",
      addCard: "Agregar Tarjeta",
      noCardsAdded: "No se han agregado tarjetas.",
      default: "Predeterminada",
      expiry: "Venc:",
    },
    pageNotFound: {
      title: "¡Parece que te has perdido! La página que solicitaste no está disponible",
      homeLink: "Regresa a la página principal.",
      imageAlt: "Página no encontrada",
    },
    paymentInformation: {
      cancel: "Cancelar",
      addCard: "Agregar Tarjeta",
      loading: "Cargando…",
      loadError: "No se pudo cargar el formulario. Comprueba tu conexión e inténtalo de nuevo.",
      stripeNotConfigured: "Stripe no está configurado.",
    },
    shop: {
      title: "Tienda",
      subtitle: "Compra tarjetas y carteles NFC para tu negocio.",
      nfcCards: "Tarjetas NFC",
      nfcSigns: "Carteles NFC",
      addToCart: "Añadir al carrito",
      quantity: "Cantidad",
      cart: "Tu carrito",
      remove: "Quitar",
      total: "Total",
      clearCart: "Vaciar carrito",
      checkout: "Finalizar compra",
      shippingDescription: "Indica tu dirección de envío. Es obligatoria para realizar el pedido.",
      continueToPayment: "Continuar al pago",
      placeOrder: "Realizar pedido",
      orderPlacedTitle: "Pedido realizado",
      orderPlacedMessage: "Hemos recibido tu pedido. Recibirás un email de confirmación.",
      errorCreatingPayment: "No se pudo crear el pago.",
      errorPayment: "Error en el pago.",
      validation: {
        line1Required: "La dirección es obligatoria",
        cityRequired: "La ciudad es obligatoria",
        postalCodeRequired: "El código postal es obligatorio",
        countryRequired: "El país es obligatorio",
      },
      shipping: {
        line1: "Dirección (línea 1)",
        line1Placeholder: "Calle y número",
        line2: "Dirección (línea 2)",
        line2Placeholder: "Piso, puerta, etc. (opcional)",
        city: "Ciudad",
        cityPlaceholder: "Ciudad",
        postalCode: "Código postal",
        postalCodePlaceholder: "Código postal",
        state: "Provincia / Región",
        statePlaceholder: "Provincia o región (opcional)",
        country: "País",
        countryPlaceholder: "País",
      },
    },
    paywall: {
      subscription: "Suscripción",
      renewDescription: "Tu suscripción requiere atención. Por favor paga las facturas pendientes o actualiza tu método de pago.",
      addPaymentMethod: "Agrega un método de pago para continuar",
      payInvoice: "Pagar Factura",
      paidOn: "Pagado El",
      summary: "Resumen",
      to: "PARA",
      from: "DE",
      invoice: "Factura",
      items: "Artículos",
      qty: "Cant",
      each: "Cada Uno",
      subtotal: "Subtotal",
      totalDue: "Total a Pagar",
      amountPaid: "Monto Pagado",
      amountRemaining: "Monto Restante",
      payNow: "Pagar Ahora",
      noInvoices: "No se encontraron facturas pendientes.",
    },
  },
};
